<template>
    <!-- Categories Breakdown List-->
    <v-row class="mt-2">
      <v-col cols="12">
        <v-skeleton-loader
          v-if="loading"
          type="card"
          height="400"
        ></v-skeleton-loader>
        <v-card v-else-if="Object.keys(categories).length === 0" class="mb-4">
          <v-card-title class="text-subtitle-1 text-sm-h6">{{ t('projectSummary') }}</v-card-title>
          <v-card-text class="text-center py-8">
            <v-icon size="large" color="grey">mdi-information-outline</v-icon>
            <p class="mt-2">{{ t('noDataAvailable') }}</p>
          </v-card-text>
        </v-card>
        <v-card v-else class="mb-4">
          <v-card-title class="text-subtitle-1 text-sm-h6">{{ t('projectSummary') }}</v-card-title>
          <v-card-text >
            <v-expansion-panels >
                <v-expansion-panel
                  v-for="category in categories"
                  :key="category.id"
                >
                  <v-expansion-panel-title>
                    <div class="d-flex flex-column flex-sm-row align-start align-sm-center justify-space-between gap-2 w-100">
                      <div class="d-flex align-center">
                        <v-icon :icon="getIconClass(category.icon)" class="mr-2"/>
                        <span class="text-caption text-sm-body-1">{{ category.title }}</span>
                      </div>
                      <div class="d-flex flex-wrap align-center gap-2">
                        <v-chip
                          v-for="status in getSortedStatuses(statusCounts[category.id]?.statuses || {})"
                          :key="status.statusColor"
                          :color="status.statusColor"
                          label
                          size="small"
                          class="px-2 my-0 mx-1"
                        >
                          <template v-slot:prepend>
                            <v-icon :color="status.statusColor">{{ status.icon }}</v-icon>
                          </template>
                          <v-tooltip activator="parent" location="top">
                            <span style="white-space: pre-line">{{ status.toolTip }}</span>
                          </v-tooltip>
                          {{ status.count }}
                        </v-chip>
                      </div>
                    </div>
                  </v-expansion-panel-title>
                  <v-expansion-panel-text>
                    <v-list density="compact">
                      <v-list-item
                        v-for="subcategory in getFilteredSubcategories(category.id)"
                        :key="subcategory.id"
                      >
                        <v-list-item-title>
                          <div class="d-flex flex-column flex-sm-row align-start align-sm-center justify-space-between gap-2">
                            <span class="text-caption text-sm-body-2">{{ subcategory.title }}</span>
                            <div class="d-flex flex-wrap align-center gap-2">
                              <v-chip
                                v-for="status in getSortedStatuses(statusCounts[category.id]?.subcategories[subcategory.id]?.statuses || {})"
                                :key="status.statusColor"
                                :color="status.statusColor"
                                label
                                size="small"
                                class="px-2 my-0 mx-1"
                                @click="openUrl(status.link)"
                                clickable
                              >
                                <template v-slot:prepend>
                                  <v-icon :color="status.statusColor">{{ status.icon }}</v-icon>
                                </template>
                                <v-tooltip activator="parent" location="top">
                                  <span style="white-space: pre-line">{{ status.toolTip }}</span>
                                </v-tooltip>
                                {{ status.count }}
                              </v-chip>
                            </div>
                          </div>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>

<script src="./model.js"></script>
<style src="./style.css" scoped></style>
